var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsightsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 537.5 166.9",
    style: {
      enableBackground: "new 0 0 537.5 166.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#197E95;}\n\t.st1{fill:#002136;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.1,125.4H40v21.9l87.2-0.1c9.1,0,16.5-7.4,16.5-16.5V45.5h-21.6V125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.2,3.4H122v22.1h21.8v-5.6C143.7,10.8,136.3,3.4,127.2,3.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 125.4,
    className: "st0",
    width: 20.6,
    height: 21.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.2,
    y: 84.8,
    className: "st0",
    width: 20.6,
    height: 21.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 84.8,
    className: "st0",
    width: 20.6,
    height: 21.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.2,
    y: 45.5,
    className: "st0",
    width: 20.6,
    height: 21.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "206,39 237,39 237,64.9 247.3,64.9 247.3,3.8 237,3.8 237,29.7 206,29.7 206,3.8 195.6,3.8  195.6,64.9 206,64.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301.1,53.3l-8.9-2.4c-3.1,3.6-7.9,5.7-12.8,5.7c-6.9,0-12.7-4.2-13.8-11.2h37.2c0.5-2.6,0.4-5.3-0.1-7.9 c-2-11.2-11.6-19.7-23.3-19.7c-13,0-23.7,10.5-23.7,23.8c0,13,10.4,23.9,23.7,23.9C288.1,65.6,297.4,60.9,301.1,53.3z  M279.3,26.8c7.3,0,12.5,5.1,13.6,10.9h-27.3C266.8,31.8,272,26.8,279.3,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.2,12.9c3.7,0,6.5-2.9,6.5-6.5c0-3.6-2.9-6.5-6.5-6.5c-3.6,0-6.5,2.9-6.5,6.5 C309.8,10,312.6,12.9,316.2,12.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.1,
    y: 18.7,
    className: "st1",
    width: 10,
    height: 46.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.7,65.7c6.4,0,11.5-2.9,14.9-7v6.2h10V3.8h-10v21c-3.4-4.2-8.6-7-14.9-7c-12.7,0-23,10.5-23,23.9 C329.7,54.7,340,65.7,352.7,65.7z M353.6,27c8.1,0,14.7,6.8,14.7,14.8c0,7.9-6.6,14.7-14.7,14.7c-8.3,0-14.5-6.8-14.5-14.7 C339.1,33.7,345.4,27,353.6,27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.2,41.4c0-10,8.6-15.1,17.8-12.3V18.5c-9.2-1.5-15.1,2.4-17.8,7.8v-7.6h-10v46.2h10V41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427.9,0c-3.6,0-6.5,2.9-6.5,6.5c0,3.6,2.9,6.5,6.5,6.5c3.7,0,6.5-2.9,6.5-6.5C434.4,2.9,431.6,0,427.9,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.8,
    y: 18.7,
    className: "st1",
    width: 10,
    height: 46.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M465.1,65.6c10,0,18.4-6.3,21.8-15l-9.2-2.4c-2.2,4.9-6.7,8.4-12.6,8.4c-8,0-14.3-6.7-14.3-14.8 c0-7.9,6.2-14.8,14.3-14.8c5.8,0,10.4,3.6,12.6,8.5l9.2-2.4c-3.5-8.9-11.9-15-21.8-15c-13,0-23.7,10.5-23.7,23.8 C441.3,54.6,451.6,65.6,465.1,65.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "517.1,39.8 536.8,18.7 524.8,18.7 504.2,41.1 504.2,3.8 494.1,3.8 494.1,64.9 504.2,64.9  504.2,53.7 511.1,46.2 525.7,64.9 537.5,64.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.1,
    y: 85.8,
    className: "st1",
    width: 10.4,
    height: 61.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241,99.9c-6.6,0-11.5,3.1-14.4,6.9v-6.1h-10v46.2h10v-23.8c0-7.9,5.1-13.9,12.5-13.9c6,0,11.3,4.3,11.3,12 v25.7h10v-28.4C260.4,106.7,251.1,99.9,241,99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.2,119.8c-7.9-1.8-13.1-2.4-13.1-6.1c0-3.1,3.8-5.2,8.6-5.2c4.8,0,11.2,1.7,17.8,5.7v-9.2 c-4.3-2.4-10.2-5.1-17.8-5.1c-10.1,0-18.8,5-18.8,13.9c0,7.4,5.7,11.1,16.7,13.4c8.4,1.8,11.9,3.5,11.9,6.5 c0,3.1-3.6,5.1-8.6,5.1c-7.8,0-15.6-4.4-19.2-7.5v10.4c6.1,3.7,12.6,5.8,19.2,5.8c9.2,0,18.6-3.9,18.6-13.8 C306.5,127.3,302.5,122.5,291.2,119.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.2,
    y: 100.6,
    className: "st1",
    width: 10,
    height: 46.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.4,82c-3.6,0-6.5,2.9-6.5,6.5c0,3.6,2.9,6.5,6.5,6.5c3.7,0,6.5-2.9,6.5-6.5C325.9,84.8,323,82,319.4,82z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.8,106.7c-3.4-4.1-8.6-6.8-14.9-6.8c-13-0.2-23,9.9-23,23.2c0,13,9.7,23.2,23,23.2 c6.5,0,11.7-2.6,14.9-6.5v3.8c-0.1,9.9-5.9,14.2-13,14.2c-4.8,0-10.6-2.1-12.7-8.3h-10c2.8,12,12.9,17.4,22.9,17.4 c12.4,0,22.9-8.3,22.9-23.6v-42.7h-10V106.7z M356.7,137.3c-7.9,0-14.5-6.1-14.5-14.2c0-8,6.5-14.3,14.5-14.3 c8.1,0,14.7,6.4,14.7,14.3C371.4,131,364.7,137.3,356.7,137.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.7,99.9c-6.7,0-11.5,3.1-14.4,6.9V85.8h-10v61.1h10v-23.8c0-7.9,5-13.9,12.4-13.9 c6.1,0,11.3,4.4,11.3,12v25.7h10v-28.4C434.1,106.7,424.9,99.9,414.7,99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M457.9,131.9l0.1-22.6h14.1v-8.6H458V89.2h-9.9l-0.1,11.4h-8.7v8.6h8.7L448,132c0,13.3,10.5,18.5,24.5,14.6 v-9.7C462.6,140.3,457.9,137.2,457.9,131.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M502.2,119.8c-7.9-1.8-13.1-2.4-13.1-6.1c0-3.1,3.8-5.2,8.6-5.2c4.8,0,11.2,1.7,17.8,5.7v-9.2 c-4.3-2.4-10.2-5.1-17.8-5.1c-10.1,0-18.8,5-18.8,13.9c0,7.4,5.7,11.1,16.7,13.4c8.4,1.8,11.9,3.5,11.9,6.5 c0,3.1-3.6,5.1-8.6,5.1c-7.8,0-15.6-4.4-19.2-7.5v10.4c6.1,3.7,12.6,5.8,19.2,5.8c9.2,0,18.6-3.9,18.6-13.8 C517.5,127.3,513.5,122.5,502.2,119.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsLogo);
export default __webpack_public_path__ + "static/media/InsightsLogo.882f48d47899ed414ffe430703675892.svg";
export { ForwardRef as ReactComponent };